module.exports = __webpack_public_path__ + "img/1valvulas.68d70a14.jpg";